import React from 'react';

export default function StepName({ wert = {}, onChange }) {
  const vorname = wert?.vorname ?? '';
  const nachname = wert?.nachname ?? '';

  function aktualisiere(feld, value) {
    onChange({
      vorname,
      nachname,
      [feld]: value,
    });
  }

  return (
    <div className="ob-step-enter">
      <div className="ob-section-header">
        <span className="ob-section-num">01</span>
        <span className="ob-section-question">Wie heißt du?</span>
      </div>

      <div className="ob-name-grid">
        <label className="ob-name-field">
          <span>Vorname</span>
          <input
            type="text"
            value={vorname}
            onChange={e => aktualisiere('vorname', e.target.value)}
            placeholder="Max"
            autoComplete="given-name"
          />
        </label>

        <label className="ob-name-field">
          <span>Nachname</span>
          <input
            type="text"
            value={nachname}
            onChange={e => aktualisiere('nachname', e.target.value)}
            placeholder="Mustermann"
            autoComplete="family-name"
          />
        </label>
      </div>
    </div>
  );
}
